(() => {
  'use strict';

  const STORAGE_KEY = 'pw-collection-view';
  const SECTION_SELECTOR = '[data-results-section]';
  const VALID_VIEWS = new Set(['grid', 'list']);

  const readStoredView = () => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return VALID_VIEWS.has(stored) ? stored : 'grid';
    } catch (error) {
      return 'grid';
    }
  };

  const storeView = (view) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      // The selected view still works for this page when storage is unavailable.
    }
  };

  const applyView = (section, view) => {
    const selectedView = VALID_VIEWS.has(view) ? view : 'grid';
    section.dataset.collectionView = selectedView;
    section.querySelectorAll('[data-view-button]').forEach((button) => {
      const active = button.dataset.viewButton === selectedView;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const createButton = (view, label, icon) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pw-view-switch__button';
    button.dataset.viewButton = view;
    button.setAttribute('aria-label', `${label}weergave`);
    button.innerHTML = `${icon}<span>${label}</span>`;
    return button;
  };

  const initializeSection = (section) => {
    if (!(section instanceof Element) || section.dataset.collectionViewReady === 'true') return;
    section.dataset.collectionViewReady = 'true';

    const toolbar = section.querySelector('.pw-results-toolbar');
    if (!toolbar) return;

    const switcher = document.createElement('div');
    switcher.className = 'pw-view-switch';
    switcher.setAttribute('role', 'group');
    switcher.setAttribute('aria-label', 'Productweergave');

    const gridIcon = '<svg aria-hidden="true" viewBox="0 0 20 20"><path d="M3 3h5v5H3zM12 3h5v5h-5zM3 12h5v5H3zM12 12h5v5h-5z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    const listIcon = '<svg aria-hidden="true" viewBox="0 0 20 20"><path d="M3 4h4v4H3zM9 4h8M3 12h4v4H3zM9 12h8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg>';

    const gridButton = createButton('grid', 'Raster', gridIcon);
    const listButton = createButton('list', 'Lijst', listIcon);
    switcher.append(gridButton, listButton);
    toolbar.append(switcher);

    switcher.addEventListener('click', (event) => {
      const button = event.target.closest('[data-view-button]');
      if (!(button instanceof HTMLButtonElement)) return;
      const view = button.dataset.viewButton;
      if (!VALID_VIEWS.has(view)) return;
      storeView(view);
      applyView(section, view);
    });

    applyView(section, readStoredView());
  };

  const initializeWithin = (root) => {
    if (root instanceof Element && root.matches(SECTION_SELECTOR)) initializeSection(root);
    root.querySelectorAll?.(SECTION_SELECTOR).forEach(initializeSection);
  };

  const start = () => {
    initializeWithin(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) initializeWithin(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
